import content from '@/data/envContent.js';

const envReducer = function(state = content, action)
{
    switch (action.type) {
        default: {
            // console.log('ZOOM DEFAULT');
            return state;
        }
    }

    return state;
};

export default envReducer;